import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ToOnboarding = ({ userType = 'Existing' }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/landingprofile', { state: { userType } });
  }, [navigate, userType]);
  
  return (
    <div className="flex justify-center items-center h-screen">
      <p>Loading onboarding hub...</p>
    </div>
  );
};

export default ToOnboarding;